import { EventEmitter, Injectable } from '@angular/core';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { preLoteDetails } from 'src/app/@feature/documentos-fiscais/gestao-de-cte/gestao-de-cte.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CTeHubService {

  public prelotes_validacaoStart: EventEmitter<preLoteDetails> = new EventEmitter();
  public prelotes_validacaoEnd: EventEmitter<preLoteDetails> = new EventEmitter();

  public prelotes_recalculoStart: EventEmitter<preLoteDetails> = new EventEmitter();
  public prelotes_recalculoEnd: EventEmitter<preLoteDetails> = new EventEmitter();

  constructor() {

  }

  private hubConnection: HubConnection
  public startConnection = (onConnect) => {
    this.hubConnection = new HubConnectionBuilder().withUrl(`${environment.signalR}cteHub`).build();
    this.hubConnection
      .start()
      .then(() => {
        if (onConnect) onConnect();
      })
      .catch(err => console.log('Error while starting connection: ' + err));

    this.hubConnection.on('onReady', (connectionId) => {

    });

    this.hubConnection
      .on('prelotes_validacaoStart', (data: preLoteDetails) => {
        this.prelotes_validacaoStart.emit(data);
      });

    this.hubConnection
      .on('prelotes_validacaoEnd', (data: preLoteDetails) => {
        this.prelotes_validacaoEnd.emit(data);
      });

    this.hubConnection
      .on('prelotes_recalculoStart', (data: preLoteDetails) => {
        this.prelotes_recalculoStart.emit(data);
      });

    this.hubConnection
      .on('prelotes_recalculoEnd', (data: preLoteDetails) => {
        this.prelotes_recalculoEnd.emit(data);
      });

  }

  public conectar = (identificador: string) => {
    this.hubConnection.invoke('connect', identificador)
      .catch(err => console.error(err));
  }
}